/** --------------------------------------------------
*
*   THEME SCRIPT
*
*  -------------------------------------------------- */

(function($) {

  "use strict";

  // document ready:
  $(function() {

    /* Hook up toggle for paper submenu */
    const $paperSubmenu = $('.js-paper-submenu');
    $paperSubmenu.on('click', function(e) {
      $('html').toggleClass('show-sidebar-nav');
    });

    // Menu group links toggle
    $('.digital-paper-menu-group-part-label').on('click', function() {
      $(this).toggleClass('open');
    });

    // Fancybox
    $('[data-fancybox]').fancybox({
      buttons: [
        'slideShow',
        // 'share',
        // 'zoom',
        'fullScreen',
        'thumbs',
        'close'
      ],
      idleTime: false,
    });

    // Masonry
    $('.digital-paper-part-cluster, .digital-paper-part-group-items').imagesLoaded(function() {
      $('.digital-paper-part-cluster, .digital-paper-part-group-items').masonry({
        itemSelector: '.view-mode-teaser',
        gutter: 10,
        percentPosition: true,
      });

      // Group toggles
      $('.digital-paper-part-group-title').on('click', function() {
        console.log('title!');
        $(this).toggleClass('open closed');
        $(this).next('.digital-paper-part-group-items').toggleClass('open closed');
      });
    });

  });

})(jQuery);
